import { createStepGuard } from '@/hooks/createStepGuard'
import {
  STEP_FALLBACK_ROUTE,
  STEP_PREREQUISITES,
} from '@/pages/FollowUpReport/guards/followUpGuardConfig'
import { selectRunReport } from '@/store/api/RunReport/RunReport.selector'

export const useFollowUpGuard = createStepGuard({
  selectSlice: selectRunReport,
  prerequisites: STEP_PREREQUISITES,
  fallbacks: STEP_FALLBACK_ROUTE,
})
